import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        review: '='
    },
    template: `
        <div class="heading01">
            <h2 ng-if="vm.isDefaultLayout">{{ 'performanceReview.Current situation - Overall overview' | translate }}</h2>
            <h2 ng-if="!vm.isDefaultLayout">{{ 'performanceReview.Current situation - general overview' | translate }}</h2>
        </div>
        <div class="quiz">
            <h3 ng-if="vm.questionsByCategory" ng-repeat-start="(index, category) in vm.questionsByCategory">
                <span ng-if="vm.isDefaultLayout">{{ index !== 0 ? category.name : '' }}</span>
                <span ng-if="!vm.isDefaultLayout">{{ category.name }}</span>
            </h3>
            <div class="question" ng-repeat-end ng-repeat="question in category.questions">
                <h4 ng-bind-html="question.activeI18n.name"></h4>
                <div ng-if="question.activeI18n.description" ng-bind-html="question.activeI18n.description"></div>
                <div class="colholder" ng-if="!question.question.isCommentFieldHidden">
                    <div class="col col04 fixed">
                        <p class="desc" ng-if="vm.isDefaultLayout">{{ 'performanceReview.Filled by employee' | translate }}</p>
                        <p class="desc" ng-if="!vm.isDefaultLayout">
                            {{ 'performanceReview.To be filled by the employee prior to the performance review' | translate }}
                        </p>
                        <textarea
                            ng-disabled="vm.review.isReadOnly || vm.review.isManager"
                            ng-readOnly="vm.review.isReadOnly || vm.review.isManager"
                            class="form-control print-hide"
                            ng-model="vm.questionAnswers[question.activeI18n.questionId].answer"
                        ></textarea>
                        <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].answer}}</span>
                    </div>
                    <div class="col col02 fixed">
                        <p class="desc" ng-if="vm.isDefaultLayout">{{ 'performanceReview.Filled by manager' | translate }}</p>
                        <p class="desc" ng-if="!vm.isDefaultLayout">{{ 'performanceReview.Manager comments' | translate }}</p>
                        <textarea
                            ng-disabled="vm.review.isReadOnly || !vm.review.isManager"
                            ng-readOnly="vm.review.isReadOnly || !vm.review.isManager"
                            class="form-control print-hide"
                            ng-model="vm.questionAnswers[question.activeI18n.questionId].comment"
                        ></textarea>
                        <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].comment}}</span>
                    </div>
                </div>
                <div class="question" ng-if="question.question.isCommentFieldHidden">
                    <textarea
                        ng-disabled="vm.review.isReadOnly || (vm.review.isManager && !question.question.isAnswerEditableByManager)"
                        ng-readOnly="vm.review.isReadOnly || (vm.review.isManager && !question.question.isAnswerEditableByManager)"
                        class="form-control print-hide"
                        ng-model="vm.questionAnswers[question.activeI18n.questionId].answer"
                    ></textarea>
                    <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].answer}}</span>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($scope, $rootScope, $translate, MomentService,
                 FormFactory, ReviewResource, ReviewService,
                 REVIEW_STEP_ENUM, REVIEW_LAYOUT_ENUM) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.MomentService = MomentService;
        this.FormFactory = FormFactory;
        this.ReviewResource = ReviewResource;
        this.ReviewService = ReviewService;
        this.REVIEW_STEP_ENUM = REVIEW_STEP_ENUM;
        this.REVIEW_LAYOUT_ENUM = REVIEW_LAYOUT_ENUM;
        $scope.$on('review:save', () => this.save());
        $rootScope.$on('review:language', (event, language) => this.loadQuestions(language));
    }

    $onInit () {
        this.loadQuestions(this.$translate.use());
        this.isDefaultLayout = this.review.form.layoutType === this.REVIEW_LAYOUT_ENUM.DEFAULT;
    }

    loadQuestions (_lang) {
        this.ReviewResource.question({
            guid: this.review.guid,
            stepType: this.REVIEW_STEP_ENUM.OVERALL_OVERVIEW,
            _lang,
            expand: 'activeI18n'
        }).$promise.then(questionsByCategory => {
            this.questionsByCategory = questionsByCategory;
            this.questionAnswers = this.ReviewService.getQuestionAnswers(questionsByCategory, this.review);
        });
    }

    save () {
        this.ReviewResource.setAnswers({ guid: this.review.guid }, this.questionAnswers).$promise
            .then((storedAnswers) => {
                this.ReviewService.updateQuestionAnswers(storedAnswers, this.review);
                this.$scope.$emit('review:save:success');
            })
            .catch(() => this.$scope.$emit('review:save:error'));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/default/overview/index.js